export enum ButtonPropsBorderSide {
  All,
  Right,
  Left
}
